import { ComplaintPage } from 'components/template/complaint';
import { IComplaint } from 'constants/types';
import { ParsedUrlQuery } from 'querystring';
import { ssrApi } from 'api/ssr';
import { isValidEntity, notFoundResult } from 'utils/ssr-not-found';

export default function Complaint({
  mainComplaint,
  childrenComplaints,
}: {
  mainComplaint: IComplaint;
  childrenComplaints: IComplaint[];
}) {
  return (
    <ComplaintPage
      mainComplaint={mainComplaint}
      childrenComplaints={childrenComplaints}
    />
  );
}

export async function getServerSideProps({ query }: { query: ParsedUrlQuery }) {
  const { id } = query;

  const mainComplaint = await ssrApi.complaints.getById(id?.toString());

  const { results: childrenComplaints } = await ssrApi.complaints.getByParentId(
    id?.toString()
  );

  if (!isValidEntity(mainComplaint)) {
    return notFoundResult();
  }

  return {
    props: {
      mainComplaint,
      childrenComplaints: childrenComplaints?.length ? childrenComplaints : [],
    },
  };
}
